const Facilities = [

    {
        image : "/images/pipe2.jpeg",
        title : "Pigging Loop Test Facility"
    },

    {
        image : "/images/site.jpeg",
        title : "Pipeline Storage Area 26\" size"
    },

    {
        image : "/images/warehouse.jpeg",
        title : "Pipeline Storage Area 4\" size"
    },

    {
        image : "/images/seabed.jpg",
        title : "Subsea Mattress Storage"
    },

    {
        image : "/images/bombpit.jpeg",
        title : "Radiation Source - Bomb Pit"
    },

    {
        image : "/images/workingarea.jpeg",
        title : "Working Area"
    },
];
export default Facilities;